import { Flex, Image, Box } from '@chakra-ui/react';
import { StyledSubtitle, StyledLink } from './styles';

interface BlogItem {
    title: string;
    image: {
        url: string;
        alt: string;
    };
    link: {
        label: string;
        href: string;
        target: string;
    };
}

const BlogItem: React.FC<BlogItem> = ({ title, image, link }) => {
    return (
        //TODO  Przepisać na chakra UI
        <Flex
            background={'white'}
            alignItems={'flex-start'}
            justifyContent={'space-between'}
            flexDirection={'column'}
        >
            <Box padding="30px">
                <StyledSubtitle>{title}</StyledSubtitle>
                <StyledLink href={link.href} target={link.target}>
                    {link.label}
                </StyledLink>
            </Box>
            <Image src={image.url} alt={image.alt} objectFit={'cover'} />
        </Flex>
    );
};

export default BlogItem;
